import React, { useEffect, useEffectEvent, useRef, useState } from 'react';
import { Row, Col, Button } from 'antd';
import { IconButton } from '@mui/material';
import { Delete } from '@mui/icons-material';
import AudioRecorder from 'features/AudeoRecorderNew';
import AudioPicker from '../../../components/AdminBooks/AudioPicker';
import { v4 as uuidv4 } from 'uuid';
import COLOR from 'utils/constants/color';
import styled from 'styled-components';
import TextEditor from 'components/TextEditor';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import { handleAudioTranscript } from 'store/submissions/thunks';

const Question = styled.div`
    color: ${COLOR.black100};
    display: block;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    margin-bottom:10px
`;

const AudioWithEssay = ({ questions = [], setQuestions, groupKey, setButtonDisabled, index , showResponsePreview=true }) => {
    const [questionText, setQuestionText] = useState({ index: null, value: '' });
    const questionRefs = useRef({});

    const handleAudioChange = (value) => {
        if (value) {
            handleAudioTranscript(value);
        }
        setQuestions(questions.map(q => {
            if (q.groupKey === groupKey) {
                return { ...q, audio: value };
            }
            return q;
        }))
    };

    const handleAddQuestion = () => {
        const newQuestion = {
            id: uuidv4(),
            type: 'audioEssay',
            groupKey,
            audio: questions[0]?.audio,
            question: '',
        };
        const new_data = [...questions, newQuestion]
        setQuestions(new_data);
        setTimeout(() => {
            if (questionRefs.current[`${new_data.length - 1}-q`]) {
                questionRefs.current[`${new_data.length - 1}-q`].focus();
            }
        }, 500);
    };

    const handleQuestionChange = useEffectEvent((index, key, value) => {
        const updated = [...questions];
        updated[index][key] = value;
        setQuestions(updated);
    });

    const handleDeleteQuestion = useEffectEvent((index) => {
        const updated = [...questions];
        updated.splice(index, 1);
        setQuestions(updated);
    });

    useEffect(() => {
        if (questionText.index !== null) {
            handleQuestionChange(questionText.index, "question", questionText.value)
        }
    }, [questionText])

    return (
        <div style={{ border: '1px dashed #aaa', padding: '16px', borderRadius: '8px' }}>
            <AudioRecorder
                handleAudio={handleAudioChange}
                index={index}
                currentSubmission={{}}
                refresh={() => { }}
                source={questions[0]?.audio}
                hasSaveButton
                message={`Record question audio`}
                setButtonDisabled={(value) => setButtonDisabled(value)}
            />
            <p style={{ textAlign: 'center' }}>OR</p>
            <AudioPicker
                onChange={handleAudioChange}
                message={"Upload a audio file for question..."}
                setButtonDisabled={(value) => setButtonDisabled(value)}
            />

            {questions.map((q, index) => (
                <div key={index} style={{ marginTop: '24px', borderTop: '1px solid #ddd', paddingTop: '16px' }}>
                    <Row justify="space-between" align="middle">
                        <Col>
                          {questions.length > 1 ? <h4>Question {index + 1}*</h4> : null}
                        </Col>
                        <Col>
                            {questions.length <= 1 ? null : (
                                <IconButton onClick={() => handleDeleteQuestion(index)}>
                                    <Delete color="secondary" />
                                </IconButton>
                            )}
                        </Col>
                    </Row>
                    <Question style={{ marginTop: 6 }}>
                        <label style={{ marginBottom: 0, fontSize: 12, fontWeight: 400 }}>Instruction*</label>
                        <TextEditor
                            handleChange={(value) => {
                                setQuestionText({ index: index, value: value })

                            }}
                            value={q.question || ''}
                            autoFocus={false}
                            disabled={false}
                            placeholder="Type your question here..."
                            containerClassName='audio-essay-question-field'
                        />
                    </Question>
                    {showResponsePreview && <div className='setupQuesInfo'>
                        <InfoOutlineIcon /><label>Text below will display the student answer...</label>
                    </div>}
                   {showResponsePreview && <Row gutter={[0, 24]} style={{ marginTop: '16px' }}>
                        <Col span={24}>
                            <TextEditor
                                handleChange={() => { }}
                                value={''}
                                autoFocus={false}
                                disabled={true}
                                containerClassName='question-ebook-text-field'
                            />
                        </Col>
                    </Row>}
                </div>
            ))}

            <Button
                type="primary"
                onClick={handleAddQuestion}
                disabled={!questions[0]?.audio}
                style={{ marginTop: '16px' }}
            >
                Add Sub-Question
            </Button>
        </div>
    );
};

export default AudioWithEssay;